const notification = {
	name: 'Notification | Notifications',
	icon: 'fa-fw fas fa-bells',
	fields: {
		type: 'Type',
		data: {
			email: 'Recipient',
		},
		created_at: 'Sent on',
		read_at: '@:common.readOn',
	},
}

export default notification
